(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mt-contact-form]').forEach((form) => {
      if (form.dataset.contactReady) return;
      form.dataset.contactReady = 'true';
      const fields = Array.from(form.querySelectorAll('[data-contact-field]'));
      const summary = form.querySelector('[data-contact-validation-summary]');
      const serverState = form.querySelector('[data-contact-state]');
      const draftKey = `mt-contact-draft:${location.pathname}:${form.id}`;
      const controls = fields.map((field) => field.querySelector('input,select,textarea'));

      // Keep a submitted draft in this tab only, for a Shopify validation return.
      // No form values are sent anywhere by this script.
      try {
        const draft = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
        if (serverState?.dataset.contactState === 'error' && draft && Date.now() - draft.savedAt < 30 * 60 * 1000) {
          controls.forEach((control) => {
            if (!control.value && typeof draft.values?.[control.name] === 'string') control.value = draft.values[control.name];
          });
        }
        sessionStorage.removeItem(draftKey);
      } catch (_) { /* The native form also works when storage is unavailable. */ }

      const validate = (field) => {
        const control = field.querySelector('input,select,textarea');
        const error = field.querySelector('[data-contact-error]');
        const type = field.dataset.contactField;
        let message = '';
        control.setCustomValidity('');
        if (control.required && !control.value.trim()) {
          message = { name: 'Please enter your name.', email: 'Please enter your email address.', enquiry_type: 'Please select an enquiry type.', body: 'Please enter a message.' }[type] || 'Please complete this field.';
        } else if (control.validity.typeMismatch) {
          message = 'Please enter a valid email address.';
        } else if (!control.validity.valid) {
          message = 'Please check this field.';
        }
        control.setCustomValidity(message);
        control.setAttribute('aria-invalid', message ? 'true' : 'false');
        error.textContent = message;
        error.hidden = !message;
        return !message;
      };

      fields.forEach((field) => {
        const control = field.querySelector('input,select,textarea');
        control.addEventListener('input', () => {
          if (control.getAttribute('aria-invalid') === 'true') validate(field);
        });
        control.addEventListener('change', () => validate(field));
      });

      // Enhance inline feedback; a valid submit continues through Shopify's
      // normal form action and spam protection without fetch or form.submit().
      form.noValidate = true;
      form.addEventListener('submit', (event) => {
        const invalid = fields.filter((field) => !validate(field));
        summary.hidden = invalid.length === 0;
        if (invalid.length) {
          event.preventDefault();
          invalid[0].querySelector('input,select,textarea').focus();
          return;
        }
        try {
          sessionStorage.setItem(draftKey, JSON.stringify({ savedAt: Date.now(), values: Object.fromEntries(controls.map((control) => [control.name, control.value])) }));
        } catch (_) { /* Submission does not depend on browser storage. */ }
      });
      if (serverState) serverState.focus();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
